import {
  SET_POLICY_DETAILS,
  SET_SELECTED_POLICY,
  UPDATE_CONTACT_PREFERENCES,
  UPDATE_FORMAT2_TELEPHONENUMBERS,
  UPDATE_PRINT_PREFERENCES,
  SET_SELECTED_POLICY_MEMBERSHIP_NUMBER
} from "../../actions/policy/policyActions";
import {
  SET_PHONE_NUMBER,
  DELETE_PHONE_NUMBER
} from "./../../actions/changephonenumber/ChangePhoneNumberActions";
import {SET_BANK_ACCOUNT,DELETE_BANK_ACCOUNT} from "./../../actions/changebankaccount/ChangeBankAccountActions";

import { SET_MEMBER_ADDRESS } from "./../../actions/changeaddress/ChangeAddressActions";
import { ADD_NEW_POLICY } from "./../../actions/addaplan/addAPlanActions";

import addAPlanReducer from "./addAPlanReducer";
import { SET_COVER_DETAILS } from "./../../actions/cover/CoverActions";
import { setCoverDetails } from "./../cover/CoverDetailsReducer";
import {
  SET_COVER_DOCUMENTS,
  SET_RENEWAL_DOCUMENTS
} from "../../actions/cover/CoverActions";
import {
  setCoverDocuments,
  setRenewalDocuments
} from "../cover/CoverDocumentsReducer";

const initialState = {
  policyDetails: null,
  selectedPolicy: null,
  selectedPolicyMembershipNumber: null
};

export default function policyReducer(state = initialState, action) {
  let selectedPolicy = null;
  let policyDetails = null;

  switch (action.type) {
    case SET_SELECTED_POLICY_MEMBERSHIP_NUMBER:
      return {
        ...state,
        selectedPolicyMembershipNumber: action.payload
      };
    case SET_SELECTED_POLICY:
      let policy =
        action.payload &&
        state.policyDetails &&
        state.policyDetails.Policies &&
        state.policyDetails.Policies.find(
          p => p.MembershipNumber === action.payload.MembershipNumber
        );
      return {
        ...state,
        selectedPolicy: policy
      };
    case SET_POLICY_DETAILS:
      console.log(action.payload);
      return {
        ...state,
        policyDetails: action.payload
      };
    case UPDATE_CONTACT_PREFERENCES:
      policyDetails = Object.assign({}, state.policyDetails, {
        Policies:
          state.policyDetails &&
          state.policyDetails.Policies &&
          state.policyDetails.Policies.map(policy => {
            if (policy.MembershipNumber === action.payload.MembershipNumber) {
              let newPolicy = Object.assign({}, policy, {
                PersonConsent: action.payload.PersonConsent
              });
              selectedPolicy = newPolicy;
              return newPolicy;
            }
            return policy;
          })
      });
      return {
        policyDetails,
        selectedPolicy
      };
    case UPDATE_FORMAT2_TELEPHONENUMBERS:
      policyDetails = Object.assign({}, state.policyDetails, {
        Policies:
          state.policyDetails &&
          state.policyDetails.Policies &&
          state.policyDetails.Policies.map(policy => {
            if (policy.MembershipNumber === action.payload.MembershipNumber) {
              let newPolicy = Object.assign({}, policy, {
                Members: policy.Members.map(member => {
                  if (member.IsLoggedInMember) {
                    return Object.assign({}, member, {
                      PhoneNumbers: action.payload.TelephoneNumbers
                    });
                  }
                  return member;
                })
              });
              selectedPolicy = newPolicy;
              return newPolicy;
            }
            return policy;
          })
      });
      return {
        policyDetails,
        selectedPolicy
      };
    case UPDATE_PRINT_PREFERENCES:
      policyDetails = Object.assign({}, state.policyDetails, {
        Policies:
          state.policyDetails &&
          state.policyDetails.Policies &&
          state.policyDetails.Policies.map(policy => {
            if (policy.MembershipNumber === action.payload.MembershipNumber) {
              let newPolicy = Object.assign({}, policy, {
                Members: policy.Members.map(member => {
                  if (member.IsLoggedInMember) {
                    return Object.assign({}, member, {
                      DocumentPreference: action.payload.PrintPreference
                    });
                  }
                  return member;
                })
              });
              selectedPolicy = newPolicy;
              return newPolicy;
            }
            return policy;
          })
      });

      
      return {
        policyDetails,
        selectedPolicy
      };

    case SET_PHONE_NUMBER:
      policyDetails = Object.assign({}, state.policyDetails, {
        Policies:
          state.policyDetails &&
          state.policyDetails.Policies &&
          state.policyDetails.Policies.map(policy => {
            if (policy.MembershipNumber === action.payload.MembershipNumber) {
              let newPolicy = Object.assign({}, policy, {
                Members: policy.Members.map(member => {
                  if (member.IsLoggedInMember) {
                    let phoneNumber = member.PhoneNumbers.find(phoneNumber => {
                      return (
                        phoneNumber.Type === action.payload.TelephoneNumber.Type
                      );
                    });

                    let memberPhones = member.PhoneNumbers.slice();
                    let changedPhoneNumber = action.payload.TelephoneNumber;
                    if (phoneNumber !== undefined) {
                      const indexOfPhoneNumber = member.PhoneNumbers.indexOf(
                        phoneNumber
                      );
                      if (indexOfPhoneNumber > -1) {
                        memberPhones[indexOfPhoneNumber] = changedPhoneNumber;
                      }
                    }
                    return Object.assign({}, member, {
                      PhoneNumbers: memberPhones
                    });
                  }
                  return member;
                })
              });
              selectedPolicy = newPolicy;
              return newPolicy;
            }
            return policy;
          })
      });
      return {
        policyDetails,
        selectedPolicy
      };

    case DELETE_PHONE_NUMBER:
      policyDetails = Object.assign({}, state.policyDetails, {
        Policies:
          state.policyDetails &&
          state.policyDetails.Policies &&
          state.policyDetails.Policies.map(policy => {
            if (policy.MembershipNumber === action.payload.MembershipNumber) {
              let newPolicy = Object.assign({}, policy, {
                Members: policy.Members.map(member => {
                  if (member.IsLoggedInMember) {
                    let phoneNumber = member.PhoneNumbers.find(phoneNumber => {
                      return (
                        phoneNumber.Type === action.payload.PhoneNumberType
                      );
                    });

                    let memberPhones = member.PhoneNumbers.slice();

                    if (phoneNumber !== undefined) {
                      const indexOfPhoneNumber = member.PhoneNumbers.indexOf(
                        phoneNumber
                      );
                      if (indexOfPhoneNumber > -1) {
                        let deletedPhoneNumber = {
                          Number: "",
                          AreaCode: "",
                          IntlCode: "",
                          LocalNumber: "",
                          PhoneNumberType: phoneNumber.PhoneNumberType,
                          Type: phoneNumber.Type
                        };
                        memberPhones[indexOfPhoneNumber] = deletedPhoneNumber;
                      }
                    }
                    return Object.assign({}, member, {
                      PhoneNumbers: memberPhones
                    });
                  }
                  return member;
                })
              });
              selectedPolicy = newPolicy;
              return newPolicy;
            }
            return policy;
          })
      });
      return {
        policyDetails,
        selectedPolicy
      };

    case SET_MEMBER_ADDRESS:
      policyDetails = Object.assign({}, state.policyDetails, {
        Policies:
          state.policyDetails &&
          state.policyDetails.Policies &&
          state.policyDetails.Policies.map(policy => {
            if (
              policy.MembershipNumber ===
              action.payload.MemberAddress.MembershipNumber
            ) {
              let newPolicy = Object.assign({}, policy, {
                Members: policy.Members.map(member => {
                  if (member.IsLoggedInMember) {
                    let changedAddress = {
                      Line1: member.Address.Line1,
                      Line2: action.payload.MemberAddress.Line1,
                      Line3: action.payload.MemberAddress.Line2,
                      Line4: action.payload.MemberAddress.Line3,
                      PostCode: action.payload.MemberAddress.PostCode
                    };
                    return Object.assign({}, member, {
                      Address: changedAddress
                    });
                  }
                  return member;
                })
              });
              selectedPolicy = newPolicy;
              return newPolicy;
            }
            return policy;
          })
      });
      return {
        policyDetails,
        selectedPolicy
      };
 case SET_BANK_ACCOUNT:
      policyDetails = Object.assign({}, state.policyDetails, {
        Policies:
          state.policyDetails &&
          state.policyDetails.Policies &&
          state.policyDetails.Policies.map(policy => {
            if (
              policy.MembershipNumber ===
              action.payload.MembershipNumber
            ) {
              let newPolicy = Object.assign({}, policy, {
                Members: policy.Members.map(member => {
                  if (member.IsLoggedInMember) {
                    let bank = {
                      SortCode: action.payload.MemberBank.SortCode,
                      AccountNumber: action.payload.MemberBank.AccountNumber,
                      AccountHolderName: action.payload.MemberBank.AccountHolderName,
                     
                    };
                    return Object.assign({}, member, {
                      MemberBankDetail: bank
                    });
                  }
                  return member;
                })
              });
              selectedPolicy = newPolicy;
              return newPolicy;
            }
            console.log(policy);
            return policy;
          })
      });
      return {
        policyDetails,
        selectedPolicy
      };
    case DELETE_BANK_ACCOUNT:policyDetails = Object.assign({}, state.policyDetails, {
      Policies:
        state.policyDetails &&
        state.policyDetails.Policies &&
        state.policyDetails.Policies.map(policy => {
          if (
            policy.MembershipNumber ===
            action.payload.MembershipNumber
          ) {
            let newPolicy = Object.assign({}, policy, {
              Members: policy.Members.map(member => {
                if (member.IsLoggedInMember) {
                  let deletedBankDetail = {
                    SortCode: null,
                    AccountNumber: null,
                    AccountHolderName: null,
                   
                  };
                  return Object.assign({}, member, {
                    MemberBankDetail: deletedBankDetail
                  });
                }
                return member;
              })
            });
            selectedPolicy = newPolicy;
            return newPolicy;
          }
          return policy;
        })
    });
    return {
      policyDetails,
      selectedPolicy
    };

    case ADD_NEW_POLICY:
      return addAPlanReducer(state, action);

    case SET_COVER_DETAILS:
      return setCoverDetails(state, action);

    case SET_COVER_DOCUMENTS:
      return setCoverDocuments(state, action);

    case SET_RENEWAL_DOCUMENTS:
      return setRenewalDocuments(state, action);

    default:
      return state;
  }
}
